<script setup lang="ts">
import type { TitleType } from '../bootstrap-panel';

const props = defineProps<{
    title?: string | boolean;
    //h1 is centered, div is not, default is h1
    titleType?: TitleType;
    empty?: boolean;
    readonly?: boolean;
}>();
const emit = defineEmits<{
    (event: 'action'): void;
}>();

</script>
<template>
    <div class="panel panel-default">
        <div v-if="props.title" class="panel-heading">
            <Component :is="props.titleType || 'h1'" class="panel-title">
                <slot name="title">
                    <template v-if="props.title !== true">
                        <span class="action-panel-title-upper">{{ props.title }}</span>
                    </template>
                </slot>
            </Component>
        </div>
        <div class="panel-body">
            <div class="action-panel-body">
                <div v-if="!props.empty" class="action-panel-content">
                    <slot />
                </div>
                <div v-else class="action-panel-content">
                    Aggiungi dati
                </div>
                <div v-if="!props.readonly" class="action-panel-actions">
                    <slot name="actions">
                        <button type="button" class="btn action-panel-button" @click="emit('action')">
                            <span class="bi" :class="props.empty ? 'bi-plus-lg' : 'bi-three-dots-vertical'" />
                        </button>
                    </slot>
                </div>
            </div>
            <div>
                <slot name="extra-content" />
            </div>
        </div>
    </div>
</template>
<style>
.action-panel-title-upper {
    text-transform: uppercase;
}

.action-panel-body {
    display: flex;
    align-items: stretch;
}

.action-panel-content {
    flex: 1;
    padding-right: 10px;
}

.action-panel-actions {
    flex: none;
    align-self: flex-start;
}

.action-panel-button {
    border-color: transparent;
    background-color: transparent;
}
</style>
